

import React from 'react';
import { Navigate, Outlet, Route, Routes} from 'react-router-dom';


import {  useRecoilValue, } from 'recoil';


///
import { currentUserSessionAtom } from 'library/store';

import { Login } from './Login';
import { Home } from 'features/Home';

import { ApplicationSetupForm, ApplicationSetupWhatsAppForm ,defaultApplicationSetup,
         
         
         ApplicationQueryForm, defaultApplicationQuery,
         ClassTemplateForm, defaultClassTemplate,
         ClassroomForm, defaultClassroom,
         BillingTypeForm, defaultBillingType,

         SchoolYearForm, defaultSchoolYear,
         SchoolYearClassTemplateForm, defaultSchoolYearClassTemplate,
         SchoolYearClassTemplateTimeTableForm, 
         SchoolYearClassForm, defaultSchoolYearClass, SchoolYearClassDashbordForm,

         SchoolYearBusForm, defaultSchoolYearBus,
         BusDestinationForm, defaultBusDestination,

         TeacherForm, defaultTeacher,
         EmployeeForm, defaultEmployee,
         //SchoolYearFinanceForm,
         ResourceDashboardForm,
         TimeTableForm,

         TeacherTimeTableForm,
         EntityActionReportForm,
         defaultEntityActionReport,
         ApplicationSetupEmailForm,
         ResourceTypeForm,
         defaultResourceType,
         AppreciationForm,
         defaultAppreciation,
         BasicSchoolYearForm,
         BillingSchoolYearForm,
         ClassSchoolYearForm,
         ClassCouncilForm,
         defaultClassCouncil,

         defaultSalaryComponent, SalaryComponentForm,
         defaultDeductionComponent, DeductionComponentForm,
         
         } from 'features/setup';

import { RoleForm, defaultRole,
         UserForm, defaultUser,
         GroupForm, defaultGroup } from 'features/security';

import { ExternalLibraryForm, defaultExternalLibrary,
         EnumerationForm, defaultEnumeration,
         ReportForm, defaultReport,
         ExtensionTypeForm, defaultExtensionType,
         MatrixForm, defaultMatrix,
         TarificationForm, defaultTarification,
         DeliveryForm, defaultDelivery } from 'features/configuration';


import { RegistrationForm, defaultRegistration,
         PersonForm, defaultPerson, StudentForm,
         SchoolYearClassSubjectMarkForm, defaultSchoolYearClassSubjectMark,
         SchoolYearClassReportCardForm,
         defaultSchoolYearClassReportCard,
         AdmissionForm,
         defaultAdmission,
         ExpenseForm,
         defaultExpense,
         defaultResource,
         ResourceForm,

         defaultAdvanceOnSalary, AdvanceOnSalaryForm,
         defaultEmployeeDeduction, EmployeeDeductionForm,
         MarkDashboardForm,
         AbsenceDisciplinaryMarkForm, defaultSchoolYearClassDisciplinaryMark,
         PreRegistrationsForm
         } from 'features/production';

import { BillingForm, defaultBilling,
         TellerOperationForm, defaultTellerOperation, //defaultTellerOperationEx,
         TellerDayClosingForm, defaultTellerDayClosing,
         PaymentForm, defaultPayment,
         PaymentOperationForm, defaultPaymentOperation,
         TellerOperationDashboardForm, BillingDashboardForm,
         CashControlForm,
         defaultCashControl,
         CashOutForm,
         defaultCashOut,
         defaultCashIn,
         CashInForm,
         defaultPayrollProcessing,
         PayrollProcessingForm,
         } from 'features/finance';

import { JobForm, defaultJob,
         SmsApiForm, defaultSmsApi,
         CertificateTemplateForm, defaultCertificateTemplate,
         CertificateAllocationForm, defaultCertificateAllocation,
         HookDataTemplateForm, defaultHookDataTemplate,
         HookDataForm, defaultHookData,
         EditionForm, defaultEdition,
         InstantMessageForm,
         defaultReportProcessing} from 'features/misc';


import { PasswordChangeForm, defaultPasswordChange } from 'features/identity';
            

const ProtectedRoute = ( props: {redirectPath?: string} ) : React.ReactElement => {
    
    const {redirectPath} = props;

    const {isAuthenticated } = useRecoilValue(currentUserSessionAtom);
    
    return !isAuthenticated ? <Navigate to={redirectPath || '/login'} replace /> : <Outlet />;
}


export const AppRoute = () => {
    
    const {shouldResetPassword } = useRecoilValue(currentUserSessionAtom);

    return (
        shouldResetPassword?     
        <Routes>
            <Route element={<ProtectedRoute />}>
                <Route path="*" element={<PasswordChangeForm {...defaultPasswordChange} />} />
            </Route>
        </Routes> :
    <Routes>
        <Route index element={<Login />} />
        <Route path="login" element={<Login />} />
        
        <Route element={<ProtectedRoute />}>
          <Route path="home" element={<Home />} />

          {/* ------ Setup ----- */} 
          <Route path="applicationSetup/:id" element={<ApplicationSetupForm {...defaultApplicationSetup} />} />
          <Route path="entityActionReport/:id" element={<EntityActionReportForm {...defaultEntityActionReport} />} />
          
          <Route path="applicationQuery/:id" element={<ApplicationQueryForm {...defaultApplicationQuery} />} />
                   
          
          <Route path="classTemplate/:id" element={<ClassTemplateForm {...defaultClassTemplate} />} />          
          <Route path="billingType/:id" element={<BillingTypeForm {...defaultBillingType} />} />
          <Route path="busDestination/:id" element={<BusDestinationForm {...defaultBusDestination} />} />          

          <Route path="classroom/:id" element={<ClassroomForm {...defaultClassroom} />} />

          <Route path="appreciation/:id" element={<AppreciationForm {...defaultAppreciation} />} />
          
          <Route path="schoolYear/:id" element={<SchoolYearForm {...defaultSchoolYear} />} />
          <Route path="basicSchoolYear/:id" element={<BasicSchoolYearForm {...defaultSchoolYear} />} />
          <Route path="billingSchoolYear/:id" element={<BillingSchoolYearForm {...defaultSchoolYear} />} />
          <Route path="classSchoolYear/:id" element={<ClassSchoolYearForm {...defaultSchoolYear} />} />

          <Route path="timeTable/:id" element={<TimeTableForm />} />

          <Route path="schoolYearClassTemplate/:id" element={<SchoolYearClassTemplateForm {...defaultSchoolYearClassTemplate} />} />
          <Route path="schoolYearClassTemplateExam/:id" element={<SchoolYearClassTemplateTimeTableForm />} />
          
          
          <Route path="schoolYearBus/:id" element={<SchoolYearBusForm {...defaultSchoolYearBus} />} />

          <Route path="schoolYearClass/:id" element={<SchoolYearClassForm {...defaultSchoolYearClass} />} />
          <Route path="schoolYearClassDashboard/:id" element={<SchoolYearClassDashbordForm  />} />

          

          <Route path="classCouncil/:id" element={<ClassCouncilForm {...defaultClassCouncil} />} />

          <Route path="teacher/:id" element={<TeacherForm {...defaultTeacher} />} />
          <Route path="teacherTimeTable/:id" element={<TeacherTimeTableForm />} />

          <Route path="resourceType/:id" element={<ResourceTypeForm {...defaultResourceType} />} />

          <Route path="employee/:id" element={<EmployeeForm {...defaultEmployee} />} />

          <Route path="salaryComponent/:id" element={<SalaryComponentForm {...defaultSalaryComponent} />} />
          <Route path="deductionComponent/:id" element={<DeductionComponentForm {...defaultDeductionComponent} />} />

          {/* ------ Security ----- */}
          <Route path="role/:id" element={<RoleForm {...defaultRole} />} />
          <Route path="user/:id" element={<UserForm {...defaultUser} />} />
          <Route path="group/:id" element={<GroupForm {...defaultGroup} />} />

          {/* ------ Configuration ----- */}
          <Route path="externalLibrary/:id" element={<ExternalLibraryForm {...defaultExternalLibrary} />} />
          <Route path="extensionType/:id" element={<ExtensionTypeForm {...defaultExtensionType} />} />
          <Route path="enumeration/:id" element={<EnumerationForm {...defaultEnumeration} />} />
          <Route path="report/:id" element={<ReportForm {...defaultReport} />} />

          <Route path="matrix/:id" element={<MatrixForm {...defaultMatrix} />} />
          <Route path="tarification/:id" element={<TarificationForm {...defaultTarification} />} />


          <Route path="delivery/:id" element={<DeliveryForm {...defaultDelivery} />} />

          <Route path="resourceDashboard/:id" element={<ResourceDashboardForm {...defaultSchoolYear} />} />

          {/* ------ Production ----- */}
          <Route path="markDashboard/:id" element={<MarkDashboardForm />} />

          <Route path="admission/:id" element={<AdmissionForm {...defaultAdmission} />} />
          <Route path="registration/:id" element={<RegistrationForm {...defaultRegistration} />} />

          <Route path="preRegistrations/:id" element={<PreRegistrationsForm />} />

          <Route path="person/:id" element={<PersonForm {...defaultPerson} />} />
          
          <Route path="classExamMark/:id" element={<SchoolYearClassSubjectMarkForm {...defaultSchoolYearClassSubjectMark} />} />
          <Route path="absenceDisciplinaryMark/:id" element={<AbsenceDisciplinaryMarkForm {...defaultSchoolYearClassDisciplinaryMark} />} />

          <Route path="reportCard/:id" element={<SchoolYearClassReportCardForm {...defaultSchoolYearClassReportCard} />} />
          
          <Route path="student/:id" element={<StudentForm {...defaultRegistration} />} />

          <Route path="resource/:id" element={<ResourceForm {...defaultResource} />} />
          <Route path="expense/:id" element={<ExpenseForm {...defaultExpense} />} />

          <Route path="advanceOnSalary/:id" element={<AdvanceOnSalaryForm {...defaultAdvanceOnSalary} />} />
          <Route path="employeeDeduction/:id" element={<EmployeeDeductionForm {...defaultEmployeeDeduction} />} />
          
          {/* ------ Finance ----- */}
        
          {/* <Route path="schoolYearFinance/:id" element={<SchoolYearFinanceForm {...defaultSchoolYear} />} /> */}
          <Route path="tellerOperationDashboard/:id" element={<TellerOperationDashboardForm />} />
          <Route path="billingDashboard/:id" element={<BillingDashboardForm />} />

          <Route path="billing/:id" element={<BillingForm {...defaultBilling} />} />

          <Route path="tellerOperation/newOperation" element={<TellerOperationForm {...defaultTellerOperation} />} />

          <Route path="tellerOperation/:id" element={<TellerOperationForm {...defaultTellerOperation} />} />
          <Route path="tellerDayClosing/:id" element={<TellerDayClosingForm {...defaultTellerDayClosing} />} />

          <Route path="payment/:id" element={<PaymentForm {...defaultPayment} />} />
          <Route path="paymentOperation/:id" element={<PaymentOperationForm {...defaultPaymentOperation} />} />

          <Route path="cashControl/:id" element={<CashControlForm {...defaultCashControl} />} />
          <Route path="cashOut/:id" element={<CashOutForm {...defaultCashOut} />} />
          <Route path="cashIn/:id" element={<CashInForm {...defaultCashIn} />} />

          <Route path="payrollProcessing/:id" element={<PayrollProcessingForm {...defaultPayrollProcessing} />} />

          {/* ------ Misc ----- */}
          <Route path="job/:id" element={<JobForm {...defaultJob} />} />
          <Route path="smsApi/:id" element={<SmsApiForm {...defaultSmsApi} />} />
          <Route path="applicationSetupWhatsApp/:id" element={<ApplicationSetupWhatsAppForm {...defaultApplicationSetup} />} />
          <Route path="applicationSetupEmail/:id" element={<ApplicationSetupEmailForm {...defaultApplicationSetup} />} />

          <Route path="certificateTemplate/:id" element={<CertificateTemplateForm {...defaultCertificateTemplate} />} />
          <Route path="certificateAllocation/:id" element={<CertificateAllocationForm {...defaultCertificateAllocation} />} />

          <Route path="hookDataTemplate/:id" element={<HookDataTemplateForm {...defaultHookDataTemplate} />} />
          <Route path="hookData/:id" element={<HookDataForm {...defaultHookData} />} />

          <Route path="edition/:id" element={<EditionForm {...defaultEdition} />} />

          <Route path="instantMessage/:id" element={<InstantMessageForm {...defaultReportProcessing} />} />

          {/* ------ User profile ----- */}
          <Route path="passwordChange" element={<PasswordChangeForm {...defaultPasswordChange} />} />
          
        </Route>
        
        <Route path="*" element={<p>There's nothing here: 404!</p>} />
        <Route path="*" element={<Login />} />
    </Routes>
    );
    
}


